define('glu/grid/savedViews/components/savedViewsModel',['require','../../../model','../../../locale'],function(require) {
    'use strict';

    var Model = require('../../../model'),
        locale = require('../../../locale');

    return Model.extend({
        defaults: {
            name: '',
            'default': false
        },

        validators: {
            name: {
                description: locale.get('savedViewName'),
                exists: true,
                maxLength: 50
            }
        }
    });
});

